import { render, staticRenderFns } from "./WalletsView.vue?vue&type=template&id=41769400"
import script from "./WalletsView.vue?vue&type=script&lang=ts"
export * from "./WalletsView.vue?vue&type=script&lang=ts"
import style0 from "./WalletsView.vue?vue&type=style&index=0&id=41769400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports